import React, { useEffect, useState, useMemo } from "react";
import Button from "@mui/material/Button";
import { Autocomplete, TextField } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import { useDispatch } from "react-redux";
//import domainsValues from "../pages/profileOrganization/domains_values.json";
import opencti_sectors from "../pages/profileOrganization/opencti_sectors.json";
import {
  checkDomainName,
  launchTeaserReportAndSave,
  requestCreatingOrganizationProfile,
} from "../redux/actions/organizationProfileCreators";
import { useHistory } from "react-router-dom";
import validator from "validator";
import TeaserReportConfirm from "./TeaserReportConfirm";
import { useFormik } from "formik";
import * as Yup from "yup";
import regions from "./regions.json";

const CreateOrgaName = ({ open, handleClose, isMobile }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const language = localStorage.getItem("i18nextLng");

  const [teaserReportOpen, setTeaserReportOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validationSchema = Yup.object({
    name: Yup.string()
      .required(t("required_field"))
      .test("is-fqdn", t("invalid_domain_name"), (value) =>
        validator.isFQDN(value || "")
      ),
    field: Yup.object().nullable().required(t("required_field")),
    selectedSubSector: Yup.object()
      .nullable()
      .when("field", {
        is: (field) => field && field.subsectors && field.subsectors.length > 0,
        then: (schema) => schema.nullable().required(t("required_field")),
        otherwise: (schema) => schema.notRequired(),
      }),
    numberOfEmployees: Yup.number()
      .integer(t("number_must_be_integer"))
      .positive(t("number_must_be_positive"))
      .required(t("required_field")),
    turnover: Yup.number()
      .positive(t("number_must_be_positive"))
      .required(t("required_field")),
    selectedRegion: Yup.object().nullable().required(t("required_field")),
    selectedCountry: Yup.string()
      .nullable()
      .when("selectedRegion", {
        is: (region) => region && region.countries.length > 0,
        then: (schema) => schema.nullable().required(t("required_field")),
        otherwise: (schema) => schema.notRequired(),
      }),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      field: null,
      selectedSubSector: null,
      numberOfEmployees: "",
      turnover: "",
      selectedRegion: null,
      selectedCountry: null,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      await handleCreation(values);
    },
  });

  // Reset form when dialog closes
  useEffect(() => {
    if (!open) {
      formik.resetForm();
    }
  }, [open]);

  const subSectorOptions = useMemo(() => {
    if (
      formik.values.field &&
      formik.values.field.subsectors
      // formik.values.field.subsectors &&
      // formik.values.field.subsector_fr
    ) {
      return formik.values.field.subsectors.map((sub, index) => ({
        subsectors: sub,
        // subsectors_fr: formik.values.field.subsector_fr[index],
      }));
    }
    return [];
  }, [formik.values.field]);

  const getLocalizedLabel = (option, key) => {
    if (!option) return "";
    return language === "fr" ? option[`${key}_fr`] : option[key];
  };

  const handleCreation = async (values) => {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    try {
      const { valid, message } = await checkDomainName(values.name);
      if (valid) {
        // const data = {
        //   name_A: values.name,
        //   domaine_A: values.field ? (language === 'fr' ? values.field.sector_fr : values.field.sector) : null,
        //   sub_sector: values.selectedSubSector ? (language === 'fr' ? values.selectedSubSector.subsector_fr : values.selectedSubSector.subsector) : null,
        //   number_of_employees_B: Number(values.numberOfEmployees),
        //   head_office_country_B: values.selectedCountry ? t(values.selectedCountry) : null,
        //   region: values.selectedRegion ? getLocalizedLabel(values.selectedRegion, "name") : null,
        // };

        // payload in english

        const data = {
          name_A: values.name,
          domaine_A: values.field ? values.field.sector : null,
          sub_sector: values.selectedSubSector
            ? values.selectedSubSector.subsectors
            : null,
          number_of_employees_B: Number(values.numberOfEmployees),
          turnover_A: Number(values.turnover),
          head_office_country_B: values.selectedCountry
            ? t(values.selectedCountry, { lng: "en" })
            : null,
          region: values.selectedRegion ? values.selectedRegion.name : null,
        };
        await dispatch(requestCreatingOrganizationProfile(data, history, t));
        handleClose();
      } else {
        formik.setFieldError("name", message);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  async function handleTeaserReportConfirm() {
    // Trigger validation
    const errors = await formik.validateForm();
    if (Object.keys(errors).length > 0) {
      formik.setTouched(errors); // Mark fields as touched to show errors
      setTeaserReportOpen(false);
      return;
    }

    const { valid, message } = await checkDomainName(formik.values.name);
    if (valid) {
      // const data = {
      //   name_A: formik.values.name,
      //   domaine_A: formik.values.field ? (language === 'fr' ? formik.values.field.sector_fr : formik.values.field.sector) : null,
      //   sub_sector: formik.values.selectedSubSector ? (language === 'fr' ? formik.values.selectedSubSector.subsector_fr : formik.values.selectedSubSector.subsector) : null,
      //   number_of_employees_B: Number(formik.values.numberOfEmployees),
      //   head_office_country_B: formik.values.selectedCountry ? t(formik.values.selectedCountry) : null,
      //   region: formik.values.selectedRegion ? getLocalizedLabel(formik.values.selectedRegion, "name") : null,
      //   confirm: "true",
      // };

      // payload in english

      const data = {
        name_A: formik.values.name,
        domaine_A: formik.values.field ? formik.values.field.sector : null,
        sub_sector: formik.values.selectedSubSector
          ? formik.values.selectedSubSector.subsectors
          : null,
        number_of_employees_B: Number(formik.values.numberOfEmployees),
        turnover: Number(formik.values.turnover),
        head_office_country_B: formik.values.selectedCountry
          ? t(formik.values.selectedCountry, { lng: "en" })
          : null,
        region: formik.values.selectedRegion
          ? formik.values.selectedRegion.name
          : null,
        confirm: "true",
      };
      dispatch(launchTeaserReportAndSave(data));
      setTeaserReportOpen(false);
      handleClose();
    } else {
      formik.setFieldError("name", message);
      setTeaserReportOpen(false);
    }
  }

  async function openTeaserReport() {
    // Manually trigger validation before opening confirm dialog
    formik.validateForm().then(async (errors) => {
      if (Object.keys(errors).length === 0) {
        const { valid, message } = await checkDomainName(formik.values.name);
        if (valid) {
          setTeaserReportOpen(true);
        } else {
          formik.setFieldError("name", message);
        }
      } else {
        formik.setTouched(errors);
      }
    });
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          lg: { width: "100%" },
        }}
        fullWidth
      >
        <Typography
          variant="subtitle3"
          sx={{
            display: "flex",
            alignItems: "center",
            mb: 2,
            mt: 2,
            cursor: "pointer",
          }}
          onClick={handleClose}
        >
          <IconButton>
            <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
          </IconButton>
          {t("back")}
        </Typography>
        <DialogTitle id="draggable-dialog-title" sx={{ margin: "0px 20px" }}>
          <Typography
            variant="title7"
            sx={{
              fontSize: "25px",
            }}
          >
            {" "}
            {t("create_new_organization")}
          </Typography>
        </DialogTitle>{" "}
        <form onSubmit={formik.handleSubmit}>
          <DialogContent sx={{ margin: !isMobile && "10px 20px" }}>
            <DialogContentText component="div">
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography
                    variant="title6"
                    sx={{
                      fontSize: "15px",
                      color: "#000000",
                    }}
                  >
                    {t("display_name_A")}
                  </Typography>
                  <TextField
                    id="name"
                    name="name"
                    placeholder={t("display_name_A")}
                    variant="outlined"
                    sx={{ mt: 2 }}
                    fullWidth
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    variant="title6"
                    sx={{
                      fontSize: "15px",
                      color: "#000000",
                    }}
                  >
                    {t("display_domaine_A")}
                  </Typography>
                  <Autocomplete
                    sx={{ mt: 2 }}
                    id="field"
                    name="field"
                    value={formik.values.field}
                    onChange={(event, value) => {
                      formik.setFieldValue("field", value);
                      formik.setFieldValue("selectedSubSector", null); // Reset sub-sector
                    }}
                    onBlur={formik.handleBlur}
                    // options={domainsValues}
                    options={opencti_sectors}
                    // getOptionLabel={(option) => t(option)}
                    getOptionLabel={(option) =>
                      getLocalizedLabel(option, "sector")
                    }
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("display_domaine_A")}
                        error={
                          formik.touched.field && Boolean(formik.errors.field)
                        }
                        helperText={formik.touched.field && formik.errors.field}
                      />
                    )}
                  />
                </Grid>

                {/* New Autocomplete for Sub-activity, rendered conditionally */}
                {formik.values.field &&
                  formik.values.field.subsectors &&
                  formik.values.field.subsectors.length > 0 && (
                    <Grid item xs={12}>
                      <Typography
                        variant="title6"
                        sx={{
                          fontSize: "15px",
                          color: "#000000",
                          mt: 2, // Add some top margin
                        }}
                      >
                        {t("sub_activity_label")}{" "}
                        {/* You'll need to define this in your translation files */}
                      </Typography>
                      <Autocomplete
                        sx={{ mt: 2 }}
                        id="selectedSubSector"
                        name="selectedSubSector"
                        value={formik.values.selectedSubSector}
                        onChange={(event, value) => {
                          formik.setFieldValue("selectedSubSector", value);
                        }}
                        onBlur={formik.handleBlur}
                        options={subSectorOptions}
                        getOptionLabel={(option) =>
                          // language === "fr"
                          //   ? option.subsectors_fr
                          //   : option.subsectors
                          option.subsectors
                        }
                        isOptionEqualToValue={(option, value) =>
                          option.subsectors === value.subsectors
                        }
                        fullWidth
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={t("select_sub_activity")}
                            error={
                              formik.touched.selectedSubSector &&
                              Boolean(formik.errors.selectedSubSector)
                            }
                            helperText={
                              formik.touched.selectedSubSector &&
                              formik.errors.selectedSubSector
                            }
                          />
                        )}
                      />
                    </Grid>
                  )}

                <Grid item xs={12}>
                  <Typography
                    variant="title6"
                    sx={{
                      fontSize: "15px",
                      color: "#000000",
                    }}
                  >
                    {t("number_of_employees_B")}
                  </Typography>
                  <TextField
                    id="numberOfEmployees"
                    name="numberOfEmployees"
                    placeholder={
                      language === "fr"
                        ? "Champ obligatoire. Valeur > 0"
                        : "Required field. Value > 0"
                    }
                    variant="outlined"
                    fullWidth
                    sx={{ mt: 1 }}
                    value={formik.values.numberOfEmployees}
                    onChange={(e) => {
                      const onlyDigits = e.target.value.replace(/\D+/g, "");
                      formik.setFieldValue("numberOfEmployees", onlyDigits);
                    }}
                    onBlur={formik.handleBlur}
                    inputProps={{
                      type: "number",
                      step: 1,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    }}
                    onKeyDown={(e) => {
                      if ([".", "-", "+", "e", "E"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    error={
                      formik.touched.numberOfEmployees &&
                      Boolean(formik.errors.numberOfEmployees)
                    }
                    helperText={
                      formik.touched.numberOfEmployees &&
                      formik.errors.numberOfEmployees
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    variant="title6"
                    sx={{
                      fontSize: "15px",
                      color: "#000000",
                    }}
                  >
                    {t("turnover_k")}
                  </Typography>
                  <TextField
                    id="turnover"
                    name="turnover"
                    placeholder={
                      language === "fr"
                        ? "Champ obligatoire."
                        : "Required field."
                    }
                    variant="outlined"
                    fullWidth
                    sx={{ mt: 1 }}
                    value={formik.values.turnover}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    inputProps={{
                      type: "number",
                    }}
                    error={
                      formik.touched.turnover && Boolean(formik.errors.turnover)
                    }
                    helperText={
                      formik.touched.turnover && formik.errors.turnover
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontSize: "15px",
                      color: "#000000",
                      mb: 1,
                    }}
                  >
                    {t("display_region")}
                  </Typography>
                  <Autocomplete
                    id="selectedRegion"
                    name="selectedRegion"
                    options={regions}
                    value={formik.values.selectedRegion}
                    getOptionLabel={(option) =>
                      getLocalizedLabel(option, "name")
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.name === value.name
                    }
                    onChange={(event, value) => {
                      formik.setFieldValue("selectedRegion", value);
                      formik.setFieldValue("selectedCountry", null);
                    }}
                    onBlur={formik.handleBlur}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={
                          formik.touched.selectedRegion &&
                          Boolean(formik.errors.selectedRegion)
                        }
                        helperText={
                          formik.touched.selectedRegion &&
                          formik.errors.selectedRegion
                        }
                      />
                    )}
                  />
                </Grid>

                {formik.values.selectedRegion && (
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontSize: "15px",
                        color: "#000000",
                        mb: 1,
                      }}
                    >
                      {t("head_office_country_B")}
                    </Typography>
                    <Autocomplete
                      sx={{ width: "100%" }}
                      id="selectedCountry"
                      name="selectedCountry"
                      disabled={!formik.values.selectedRegion}
                      options={
                        formik.values.selectedRegion
                          ? formik.values.selectedRegion.countries
                          : []
                      }
                      value={formik.values.selectedCountry}
                      onChange={(event, value) => {
                        formik.setFieldValue("selectedCountry", value);
                      }}
                      getOptionLabel={(option) => t(option)} // Display the country code
                      onBlur={formik.handleBlur}
                      fullWidth
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={
                            formik.touched.selectedCountry &&
                            Boolean(formik.errors.selectedCountry)
                          }
                          helperText={
                            formik.touched.selectedCountry &&
                            formik.errors.selectedCountry
                          }
                        />
                      )}
                    />
                  </Grid>
                )}
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions align="right">
            <Grid container>
              <Grid item xs={12} align="center">
                <Button
                  variant="contained"
                  color="button"
                  type="submit"
                  disabled={!formik.isValid || !formik.dirty || isSubmitting}
                  sx={{
                    borderRadius: "10px",
                    margin: "20px 0px",
                    width: "95%",
                  }}
                >
                  {isSubmitting
                    ? t("registering_organization")
                    : t("create_new_organization")}
                </Button>
                {/* 
                <Button
                  variant="contained"
                  color="button"
                  disabled={!formik.isValid || !formik.dirty}
                  onClick={openTeaserReport}
                  sx={{
                    borderRadius: "10px",
                    margin: "0px 0px 20px 0px",
                    width: "95%",
                  }}
                >
                  {t("launch_teaser_report")}
                </Button> */}
              </Grid>
            </Grid>
          </DialogActions>
        </form>
      </Dialog>

      <TeaserReportConfirm
        open={teaserReportOpen}
        onClose={() => setTeaserReportOpen(false)}
        onConfirm={handleTeaserReportConfirm}
        message={t("teaser_report_confirm_message")}
        cancelText={t("refuse")}
        confirmText={t("confirm")}
        title={language === "fr" ? "Es-tu sûr?" : "Are you sure?"}
      />
    </div>
  );
};

export default CreateOrgaName;
